<div class="dashboard-section">
    <div class="section-header" [ngClass]="{'collapsible': isCollapsible}" (click)="toggleSection()">
        <div class="section-title-group">
            <mat-icon class="section-icon" [ngClass]="'color-' + color">{{ icon }}</mat-icon>
            <h2 class="section-title">{{ title }}</h2>
        </div>
        <mat-icon *ngIf="isCollapsible" class="expand-icon" [@.disabled]="!isExpanded">
            {{ isExpanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
    </div>

    <div class="section-content" *ngIf="isExpanded">
        <ng-content></ng-content>
    </div>
</div>